class BlogFilter {
  constructor() {
    this.settings = {
      container: document.querySelectorAll('.blog-filter-item'),
      inputs: document.querySelectorAll('.blog-filter-dropdown-content input[type="checkbox"]'),
      blogFilter: document.querySelector('.blog-filter'),
    }

    if (this.settings.blogFilter !== null) {
      this.settings.ajaxUrl = this.settings.blogFilter.dataset.ajaxUrl;
    }

    this.initializeEventListeners();
    this.toggleFilterSelect();
    this.getSelectedItemsLenght();
    this.getSelectedFilterOptions();
  }

  /**
   * @desc initialize all event listeners
   * @returns {*[]}
   */
  initializeEventListeners = () => {
    this.settings.inputs.forEach(input => {
      input.addEventListener('change', () => {
        this.getFilteredTeasers(this.getSelectedFilterOptions())
      })
    })
  }

  /**
   * @desc toggle class for opening and closing select
   */
  toggleFilterSelect = () => {
    Array.from(this.settings.container).forEach(filter => {
      let select = filter.querySelector('.blog-filter-dropdown-title');

      select.addEventListener('click', () => {
        Array.from(this.settings.container).forEach(filterNew => {
          if((filterNew !== filter) && filterNew.classList.contains('open')) {
            filterNew.classList.remove('open')
          }
        })

        filter.classList.toggle('open');
      })
    })
  }

  /**
   * @desc get length of selectet checkboxes ist same filter group
   */
  getSelectedItemsLenght = () => {
    Array.from(this.settings.container).forEach(filter => {
      let inputs = filter.querySelectorAll('.blog-filter-dropdown-content input[type="checkbox"]');

      Array.from(inputs).forEach(input => {
        input.addEventListener('change', () => {
          let selectedInputs = filter.querySelectorAll('.blog-filter-dropdown-content input[type="checkbox"]:checked'),
            activeFilterView = filter.querySelector('.active-filter');

          activeFilterView.setAttribute('data-active', selectedInputs.length)
          if(selectedInputs.length > 0) {
            activeFilterView.classList.remove('d-none');
          } else {
            activeFilterView.classList.add('d-none');
          }
        })
      })
    })
  }

  /**
   * @desc get values from filter checkboxes and returns an array with necessary information
   * @returns {*[]}
   */
  getSelectedFilterOptions = () => {
    let jobList = '',
        themeList = '',
        filter = [];

    Array.from(this.settings.inputs).forEach(input => {
      let name = input.getAttribute('name'),
        value = input.value;

      if (input.checked) {
        if (name === 'job') {
          if (jobList === '') {
            jobList = jobList + value;
          } else {
            jobList = jobList + '%2C' + value;
          }
        } else {
          if (themeList === '') {
            themeList = themeList + value;
          } else {
            themeList = themeList + '%2C' + value;
          }
        }
      }
    })

    filter['job'] = jobList;
    filter['theme'] = themeList;

    return filter;
  }

  /**
   * @desc get rendered teaser html from ajax request
   * @returns {*[]}
   */
  getFilteredTeasers = (data) => {
    let xhttp = new XMLHttpRequest(),
        ajaxUrl = this.settings.ajaxUrl + '?tx_wmd_teasers_wmdteasersfilter%5Bjob%5D=' + data['job']
                                        + '&tx_wmd_teasers_wmdteasersfilter%5Btheme%5D=' + data['theme'],
        teasersContainer = document.querySelector('#teasersContainer');

    xhttp.open('GET', ajaxUrl);
    xhttp.send();

    xhttp.onreadystatechange = (e) => {
      teasersContainer.innerHTML = xhttp.responseText;
      $('.card .resize-img').resizeToParent({
        parent: '.card-media-container'
      });

      let loadMoreBtnElem = document.getElementById('load-more');
      let shouldHideElements = data['job'] !== '' || data['theme'] !== '';

      if (loadMoreBtnElem) {
          loadMoreBtnElem.style.display = shouldHideElements ? 'none' : '';
      }
    }
  }
}

new BlogFilter();
